import React, { useContext, useEffect } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import { ApplicationFormStateContext } from '../../state/applicationFormState';
import { BackButton } from '../../components/BackButton';
import { trackEvent } from '../../utils/gtm';
import { scrollToTopOfContent } from '../../utils/scroll';
import { useNavigate } from 'react-router-dom';
import { Step } from '../../models/Step';

const CoApplicantIncomeStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const { coApplicantMonthlyIncomeGross, coApplicantMonthlyIncomeNet } = state;
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'CoApplicantIncome' } });
    dispatch({ type: 'set_step', step: Step.CoApplicantIncome });
    scrollToTopOfContent();
  }, []);

  const validationSchema = yup.object().shape({
      coApplicantMonthlyIncomeGross: yup
        .number()
        .typeError('Indtast indkomst før skat')
        .min(0, 'Indtast indkomst før skat')
        .max(999999, 'Indtast indkomst før skat')
        .required('Indtast indkomst før skat'),
      coApplicantMonthlyIncomeNet: yup
        .number()
        .typeError('Indtast udbetalt pr. måned')
        .min(0, 'Indtast udbetalt pr. måned')
        .max(999999, 'Indtast udbetalt pr. måned')
        .required('Indtast udbetalt pr. måned')
  });

  return (
    <>
      <h2>Medansøger indkomst</h2>
      
      <Formik
        initialValues={{ coApplicantMonthlyIncomeGross, coApplicantMonthlyIncomeNet }}
        onSubmit={async (values) => {

          dispatch({
            type: 'set_coApplicantIncome',
            coApplicantMonthlyIncomeGross: values.coApplicantMonthlyIncomeGross,
            coApplicantMonthlyIncomeNet: values.coApplicantMonthlyIncomeNet
          });

          navigate('/boligform');
        }}
        validationSchema={validationSchema}
      >
        {(formikProps) => (
          <div className="mt-5">
            <div>
              <label className="label-default">Indkomst før skat pr. måned</label>
              <input
                type="text"
                name="coApplicantMonthlyIncomeGross"
                placeholder="Indkomst før skat pr. måned skal angives"
                defaultValue={formikProps.values.coApplicantMonthlyIncomeGross}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={6}
              />
              
              {(formikProps.touched.coApplicantMonthlyIncomeGross ||
                formikProps.submitCount > 0) &&
                formikProps.errors.coApplicantMonthlyIncomeGross && (
                  <div className="invalid-feedback">
                    {formikProps.errors.coApplicantMonthlyIncomeGross}
                  </div>
                )}
            </div>

            <div className="mt-5">
              <label className="label-default">Udbetalt pr. måned</label>
              <input
                type="text"
                name="coApplicantMonthlyIncomeNet"
                placeholder="Indkomst efter skat pr. måned skal angives"
                defaultValue={formikProps.values.coApplicantMonthlyIncomeNet}
                disabled={formikProps.isSubmitting}
                onChange={formikProps.handleChange}
                onBlur={formikProps.handleBlur}
                maxLength={6}
              />

              {(formikProps.touched.coApplicantMonthlyIncomeNet ||
                formikProps.submitCount > 0) &&
                formikProps.errors.coApplicantMonthlyIncomeNet && (
                  <div className="invalid-feedback">
                    {formikProps.errors.coApplicantMonthlyIncomeNet}
                  </div>
                )}
            </div>

            <div className="container-btn">
              <BackButton />

              <button
                className="btn btn-next"
                type="submit"
                onClick={() => formikProps.submitForm()}
              >
                Næste
              </button>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default CoApplicantIncomeStep;
